import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DataService } from "../../data.service";
import { interval } from "rxjs/observable/interval";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-meeting-page",
  templateUrl: "./meeting-page.component.html",
  styleUrls: ["./meeting-page.component.scss"],
})
export class MeetingPageComponent implements OnInit {
  public loading: boolean;
  public mid: string;
  public email: string;
  public pin: string;
  
  public meeting: any;
  public days_to_start: number;
  public hours_to_start: number;
  public minutes_to_start: number;
  public timer: any;
  public user_name: string;
  public joining: boolean;
  public is_moderator: boolean;
  public debug = false;

  public isWebRTCSupported: boolean;

  constructor(
    public dataService: DataService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.is_moderator = window.location.pathname.indexOf('moderate_') > -1;
    this.route.queryParams.subscribe(params => {
      this.debug = !!params.debug;
    });
    this.route.params.subscribe((params) => {
      this.mid = params['mid'];
      this.email = params['email'];
      this.pin = params['pin'];
      this.update_meeting();
      // Create an Observable that will publish a value on an interval
      this.timer = interval(15000);
      // Subscribe to begin publishing values
      this.timer.subscribe((n) => {
        // console.log(`It's been ${n * 15} seconds since subscribing!`);
        this.refresh();
      });
    });

    this.isWebRTCSupported = !!window.navigator.getUserMedia;
  }

  sanitizeHtml(html: any) {
    if (!html) {
      // prevent IE to show "null"
      html = "";
    } else {
      html = html.replace('\n','<br\>');
    }

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  
  update_meeting() {
    this.loading = true;
    this.dataService.get("meeting/" + this.mid).subscribe(
      (data) => {
        console.debug(data);
        this.meeting = data.json();
        this.loading = false;
        this._update_time();
        if( this.meeting.status == 'LIVE' && this.hours_to_start < 1 && this.days_to_start < 1 ){
          this.meeting._status = 'LIVE';
          if( this.minutes_to_start > this.meeting.participants_can_join_minutes_ahead ){
            this.meeting.status = 'WAITING_FOR_MOD';
          }
          if( this.minutes_to_start > this.meeting.moderators_can_join_minutes_ahead ){
            this.meeting.status = 'WAITING_FOR_START';
          }
          
        }
      },
      (err) => {
        console.error(err);
        this.loading = false;
      }
    );
  }

  moderator_can_join(){
    if( !this.mid  ) return false;
    if( !this.email  ) return false;
    if( !this.pin  ) return false;
    if( !this.user_name  ) return false;
    return this.meeting._status == 'LIVE';    
  }

  goto_meeting() {
    let req_meeting_url = `meeting/${this.mid}?join=${this.user_name}`;
    if( this.is_moderator && this.moderator_can_join()){
      req_meeting_url += `&email=${this.email}&pin=${this.pin}`;
    }
    this.joining = true;
    this.dataService
      .get(req_meeting_url)
      .subscribe(
        (data) => {
          console.debug(data);
          this.meeting = data.json();
          this.joining = false;
          if (!!this.meeting.guest_join_url) {
            window.location.href = this.meeting.guest_join_url;
          }
        },
        (err) => {
          console.error(err);
          this.joining = false;
        }
      );
  }

  _time_diff(startDate, endDate) {
    // start = start.split(":");
    // end = end.split(":");
    // var startDate = new Date(0, 0, 0, start[0], start[1], 0);
    // var endDate = new Date(0, 0, 0, end[0], end[1], 0);
    let diff = endDate.getTime() - startDate.getTime();

    let days = Math.floor(diff / 1000 / 60 / 60 / 24);
    let diff2 = diff - days * 1000 * 60 * 60 * 24;

    let hours = Math.floor(diff2 / 1000 / 60 / 60);
    let diff3 = diff2 - hours * 1000 * 60 * 60;

    let minutes = Math.floor(diff3 / 1000 / 60);

    // If using time pickers with 24 hours format, add the below line get exact hours
    // if (hours < 0) hours = hours + 24;
    if (diff < 0) {
      if (days > 0) days = -days;
      if (hours > 0) hours = -hours;
      if (minutes > 0) minutes = -minutes;
    }

    this.days_to_start = days;
    this.hours_to_start = hours;
    this.minutes_to_start = minutes;

    return (
      (hours <= 9 ? "0" : "") +
      hours +
      ":" +
      (minutes <= 9 ? "0" : "") +
      minutes
    );
  }

  _update_time() {
    let now = new Date();
    let start_time = new Date(this.meeting.start_time);
    let time_till_start = this._time_diff(now, start_time);
    console.debug(time_till_start);
  }

  refresh() {
    if (!this.meeting) return;
    if(['ENDED', 'RECORDED'].indexOf(this.meeting.status) > -1 ) return;

    this._update_time();

    if (
      this.meeting._status != "LIVE" &&
      this.days_to_start < 1 &&
      this.hours_to_start < 1 &&
      this.minutes_to_start < this.meeting.minutes_ahead
    ) {
      this.update_meeting();
    }
  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/meeting-page/meeting-page.component.ts